import { Directive } from '@angular/core';

@Directive({
  selector: '[appMatchPassword]'
})
export class MatchPasswordDirective {

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/util/match-password-directive/match-password.directive.ts